import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import {
  Megaphone,
  Film,
  PenLine,
  Youtube,
  Plus,
  ChevronDown,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '@jeraisonne/ui';

/**
 * Raccourcis de création : un bouton par type de diffusion, qui renvoie vers
 * l'éditeur/page où ce type se crée (la console ne fait que GÉRER l'existant).
 */
const CREATE_LINKS: ReadonlyArray<{
  label: string;
  hint: string;
  icon: LucideIcon;
  to: string;
}> = [
  {
    label: 'Défi',
    hint: 'YouTube Short / TikTok',
    icon: Megaphone,
    to: '/tutor/admin/challenges',
  },
  {
    label: 'Replay d’exercice',
    hint: 'Reel Insta / TikTok',
    icon: Film,
    to: '/tutor/exercises',
  },
  {
    label: 'Clip playlist',
    hint: 'YouTube Studio',
    icon: Youtube,
    to: '/tutor/admin/youtube/new',
  },
  {
    label: 'Extrait d’article',
    hint: 'LinkedIn / Facebook / Insta',
    icon: PenLine,
    to: '/tutor/blog',
  },
];

export function DiffusionsCreateBar() {
  // Replié par défaut : la console sert d'abord à GÉRER l'existant.
  const [open, setOpen] = useState(false);

  return (
    <div className="mb-5">
      <button
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="font-display text-ink-600 hover:text-ink-900 mb-2 flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wide transition-colors"
      >
        <Plus className="h-3.5 w-3.5" /> Créer une diffusion
        <ChevronDown className={cn('h-3.5 w-3.5 transition-transform', open && 'rotate-180')} />
      </button>
      {open && (
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
          {CREATE_LINKS.map(({ label, hint, icon: Icon, to }) => (
            <Link
              key={label}
              to={to as never}
              className="border-ink-200 hover:border-primary-300 hover:bg-primary-50/40 flex min-h-11 flex-col gap-0.5 rounded-2xl border bg-white p-3 transition-all active:scale-[0.98]"
            >
              <span className="text-primary-600 inline-flex items-center gap-1.5">
                <Icon className="h-4 w-4 shrink-0" />
                <span className="font-display text-ink-900 text-[13px] font-extrabold leading-tight">
                  {label}
                </span>
              </span>
              <span className="text-ink-400 font-sans text-[11px] leading-tight">{hint}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
